import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import LoadingBalls from '@/components/Common/LoadingBalls';
import PressCard from '@/components/Press/Card';
import { _getAllLatestNews, _getAllPressRelease } from '@/service/press/press';
import styles from '@/styles/pages/Press/Press.module.scss';

export const getServerSideProps: GetServerSideProps = async () => {
  const latestNews = await _getAllLatestNews({});
  const pressRelease = await _getAllPressRelease({});
  return {
    props: {
      latestNews: latestNews,
      pressRelease: pressRelease,
    },
  };
};

const Press = ({ latestNews, pressRelease }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const [sortedData, setSortedData] = useState([]);

  useEffect(() => {
    // Combine and sort data by release date
    const allData = [...latestNews, ...pressRelease]
      .map((item) => {
        const date = new Date(item.created_at);
        return {
          original: item,
          formattedDate: `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`,
        };
      })
      .sort((a, b) => {
        const dateA = new Date(a?.original?.release).getTime();
        const dateB = new Date(b?.original?.release).getTime();
        return dateB - dateA; // Sort in descending order
      });
    setSortedData(allData); // Set the sorted data to state
  }, [latestNews, pressRelease]); // Update when props change

  const fetchMoreData = () => {
    const start = sortedData?.length;
    const end = start + 10;
    const newSortedData = sortedData.slice(0, end);
    setSortedData([...sortedData, ...newSortedData]); // Append new data
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.titleWrapper}>
          <div className={styles.title}>LandRocker in Media</div>
          <span className={styles.line} />
        </span>
        <span className={styles.subTitle}>Latest News</span>
      </div>
      <div className={styles.innerContainer}>
        <div className={styles.boxCards_container}>
          <div className={''}>
            <InfiniteScroll
              dataLength={sortedData?.length} // Updated to use sortedData
              next={fetchMoreData}
              hasMore={sortedData?.length < latestNews.length + pressRelease.length} // Corrected hasMore logic
              loader={
                <div className='flex justify-center items-center w-full my-[40px]'>
                  <LoadingBalls />
                </div>
              }
            >
              <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                {sortedData.map((items, index) => (
                  <PressCard key={index} item={items.original} />
                ))}
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Press;
